export enum ProductDescription {
  select = 0,
  standardLCOR = 1,
  affordableLTV = 2,
  other = 60,
}
